const MIN_ASPECT_RATIO = 9 / 16; // 9:16 (竖向)
const MAX_ASPECT_RATIO = 16 / 9; // 16:9 (横向)

/**
 * 计算宽高比 默认宽高比为16/9
 * @param size 宽高
 * @param forceVideoAspectRatio 是否强制宽高比为16/9
 * @param limitAspectRatio 是否限制宽高比在 16:9 和 9:16 之间，超出范围的会被裁剪为边界值
 * @returns
 */
export const getAspectRatio = ({
  size,
  forceVideoAspectRatio,
  limitAspectRatio,
}: {
  size?: {
    width?: number;
    height?: number;
  };
  forceVideoAspectRatio?: boolean;
  limitAspectRatio?: boolean;
}) => {
  if (forceVideoAspectRatio) {
    return 16 / 9;
  }

  if (!size?.width || !size?.height) {
    return 16 / 9;
  }

  const aspectRatio = size.width / size.height;

  if (limitAspectRatio) {
    // 限制宽高比在 9:16 和 16:9 之间
    if (aspectRatio < MIN_ASPECT_RATIO) {
      // 更竖向的图片，裁剪为 9:16
      return MIN_ASPECT_RATIO;
    }
    if (aspectRatio > MAX_ASPECT_RATIO) {
      // 更横向的图片，裁剪为 16:9
      return MAX_ASPECT_RATIO;
    }
  }

  return aspectRatio;
};
